<script>
    import router from "page";

    // import Datalist from "../components/Datalist.svelte";
    import DatalistDebounced from "../components/DatalistDebounced.svelte";
    import UserDropdown from "./UserDropdown.svelte";

    import {
        isAuthenticated,
        isAdmin,
        activePage,
        client,
        locale,
        cart,
        isMobile,
        searchInput,
        searchArray,
        showSidebar,
    } from "../stores.js";

    import {
        fetchGet,
        fetchPost,
        fetchDelete,
        fetchPatch,
    } from "../utils/utilsFetch";

    function toggleSidebar() {
        $showSidebar = !$showSidebar;
    }

    // DATALIST ===============================================================

    async function getProductsForDatalist(value) {
        if (value?.length >= 3) {
            let products = await fetchGet(`/api/products/search?q=${value}`);
            return products;
        }
    }

    function onEnterCallback(searchQuery) {
        router(`/products?search=${searchQuery}`);
    }

    async function navigateToDatalistSelectedProduct(sku) {
        router(`/products/${sku}`);
    }
</script>

<div class="container">
    <div class="menu-toggle fas fa-bars" on:click={toggleSidebar} />

    <a href="/">
        <div class="logo">
            <img src="/office_plus_logo.jpg" />
        </div>
    </a>

    {#if !$isAdmin}
        <DatalistDebounced
            style="margin-right: 20px"
            styleInput={$isMobile ? "width: 130px;" : ""}
            styleDropdown={$isMobile ? "width: 338px; margin-left: -80px;" : ""}
            datalistPopulationCallback={getProductsForDatalist}
            datalistSelectionCallback={navigateToDatalistSelectedProduct}
            {onEnterCallback}
            key={null}
            value={null}
            settings={{
                keyFormat: "sku",
                headers: [
                    { text: "", width: 25 },
                    { text: $locale?.sku || "", width: 60 },
                    { text: $locale?.product || "", width: 600 },
                ],
                optionValueFormat: [
                    { key: "sku", width: 60 },
                    { key: "productName", width: 600 },
                ],
                image: {
                    srcProperty: "imageLink",
                    width: 25,
                },
                descriptionNull: "",
                clearAfterSelection: true,
            }}
            placeholder={$locale?.searchDots || ""}
        />

        {#if $isMobile}
            <a href="/cart" class="cart">
                <button class="btn btn-green">
                    <i class="fas fa-shopping-cart" />
                    <div class="count">
                        {#if $cart}
                            {$cart.length}
                        {/if}
                    </div>
                </button>
            </a>

            <div class="user">
                <UserDropdown />
            </div>
        {/if}

        <!-- <div class="links links-left">
            <a href="/brands" style="margin-left: 20px;">
                <div class="nav-item" class:active={$activePage == "brands"}>
                    Брендови
                </div>
            </a>
        </div> -->

        {#if !$isMobile}
            <div class="links links-right" class:right={!$isMobile}>
                <a class="right" href="/brands">
                    <div
                        class="nav-item"
                        class:active={$activePage == "brands"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {$locale?.brands || ""}
                    </div>
                </a>

                <a href="/products?view=pricelist">
                    <div
                        class="nav-item"
                        class:active={$activePage == "pricelist"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {$locale?.pricelist || ""}
                    </div>
                </a>

                <a href="/orders">
                    <div
                        class="nav-item"
                        class:active={$activePage == "orders"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {$locale?.orders || ""}
                    </div>
                </a>

                <a href="/invoices">
                    <div
                        class="nav-item"
                        class:active={$activePage == "invoices"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {$locale?.invoices || ""}
                    </div>
                </a>
            </div>

            <a href="/cart" style="margin-right: 10px;">
                <button class="btn btn-green">
                    <i class="fas fa-shopping-cart" />
                    <div class="label">{$locale?.cart || ""}</div>
                    <div class="count">
                        {#if $cart && $cart.length > 0}
                            {$cart.length}
                        {/if}
                    </div>
                </button>
            </a>
        {/if}
    {/if}

    {#if !$isMobile}
        <div class="user" class:right={$isAdmin}>
            <UserDropdown />
        </div>
    {/if}
</div>

<style>
    .container {
        grid-column: 1/-1;
        grid-row: 1/2;

        display: flex;
        align-items: center;

        padding: 0px 5px;
        background: #333;

        z-index: 99;
    }

    .logo {
        width: 125px;
        display: flex;
        align-items: center;
        margin-right: 10px;
    }

    .logo img {
        width: 100%;
    }

    .links {
        display: flex;
        align-items: center;
    }

    .links-left {
        margin-left: 20px;
    }

    .nav-item {
        color: #888;
        margin-right: 30px;
    }

    .nav-item:hover {
        color: white;
    }

    .active {
        color: white;
    }

    .right {
        margin-left: auto;
    }

    .info {
        color: white;
        margin-right: 10px;
    }

    .logout {
        color: red;
        cursor: pointer;
    }

    .label {
        margin-left: 5px;
    }

    .count {
        margin-left: 5px;
        opacity: 0.5;
    }

    .menu-toggle {
        font-size: 30px;
        color: #999;
        cursor: pointer;
        margin-right: 10px;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            justify-content: space-between;
        }

        .logo {
            width: 100px;
        }

        .links-left {
            margin-left: 0px;
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            padding-bottom: 5px;
        }

        .nav-item {
            font-size: 14px;
            margin-right: 10px;
        }

        .menu-toggle,
        .logo {
            margin: 0px;
        }
    }
</style>
